// src/components/dashboard/SaveContactButton.jsx
//
// One tap puts a contact card — name, number, portal, email, the access note —
// into the phone's own Contacts app. A member in trouble at 2am looks in their
// contacts, not in a wellness portal, so this is the difference between the EAP
// being available and it being reachable.

import React, { useState } from 'react';
import { UserPlus, Check, Loader2 } from 'lucide-react';
import { saveContact } from '../../utils/vcard';

const SaveContactButton = ({ fields, label = 'Save to my contacts', className, onSaved }) => {
    const [state, setState] = useState('idle'); // idle | working | done

    const handleClick = async () => {
        if (state === 'working') return;
        setState('working');
        try {
            const result = await saveContact(fields);
            if (result === 'cancelled') {
                setState('idle');
                return;
            }
            setState('done');
            if (onSaved) onSaved(result);
            setTimeout(() => setState('idle'), 4000);
        } catch (err) {
            console.error('Save contact failed', err);
            setState('idle');
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={
                className ||
                'flex items-center justify-center gap-2 w-full p-3 rounded-xl bg-white text-slate-700 hover:bg-slate-50 border border-slate-200 transition-colors font-bold text-sm'
            }
        >
            {state === 'working' ? (
                <Loader2 size={16} className="shrink-0 animate-spin" />
            ) : state === 'done' ? (
                <Check size={16} className="shrink-0 text-green-600" />
            ) : (
                <UserPlus size={16} className="shrink-0 text-brand-primary" />
            )}
            {state === 'done' ? 'Added to your contacts' : label}
        </button>
    );
};

export default SaveContactButton;
